"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const react_2 = require("@connect2ic/react");
const authProvider_1 = require("@/components/authProvider/authProvider");
const react_router_dom_1 = require("react-router-dom");
const LogIn = () => {
    const { open: openLogin } = (0, react_2.useDialog)();
    const { loggedIn, principal, handleLogOut } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        if (loggedIn) {
            navigate('/stakes');
        }
    }, [loggedIn]);
    return react_1.default.createElement("div", null,
        react_1.default.createElement(origyn_art_ui_1.Container, { size: "sm" },
            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, style: { minHeight: "calc(90vh - 86px)", textAlign: "center" }, align: "center", justify: "center", flexFlow: 'column', gap: 48 },
                react_1.default.createElement("h1", null, "Connect your wallet"),
                react_1.default.createElement("p", null,
                    "Log in with your wallet to access governance functionality. ",
                    react_1.default.createElement("br", null),
                    "You can stake your token for rewards, transfer your tokens to another wallet, or manage your stakes or vestings."),
                react_1.default.createElement(origyn_art_ui_1.Button, { style: { background: "#70237D", color: "#ffffff" }, onClick: openLogin }, "Connect"))));
};
exports.default = LogIn;
